// http://design/guidelines/patterns/dialogs-1#standard-dialog-widths
export enum TabDialogWidth {
    width200px = 200,
    width260px = 260,
    width375px = 375, // When in doubt, use this
    width500px = 500,
    width600px = 600,
    width700px = 700,
    width900px = 900
}
